import { InputTypes, Widths } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";

export const configurationDetails: FieldSchema = {
  grid: {
    displayed: true,
    order: 73,
    sortable: false,
    ignoredForSearch: true,
  },
  name: "configurationDetails",
  data: { maxLength: 500 },
  display: {
    displayed: true,
  },
  form: { label: "Configuration details", type: InputTypes.TEXTAREA, width: Widths.HALF },
};
